module.exports = __webpack_public_path__ + "img/c3.b8d551cf.png";